export enum ConeCheckBy {
  GoNoGoGauge = 'Go/no-go gauge',
  Callipers = 'Callipers',
}

export * from './AS/AsDynamicConePenetrometerWorksheet';
export * from './InHouseMethod/DynamicConePenetrometerWorksheet';
